/**
 * 操作审计模块（OFBiz 新接口）
 * ------------------------------------------------------------------
 * 对应后端：POST /itoss/control/json/operationAudit/*
 * 迁移自前端原接口（odata_client.js 的 OperationAudit 段）：
 *   getOperationAuditData, createOperationAudit(直接 oData post), updateOperationAudit
 *
 * 字段映射（旧 PascalCase -> 新 camelCase）：
 *   RecId              -> noteId
 *   OperationType      -> operationType（小写 key 原样存，如 add/edit）
 *   OperationBo        -> module（操作对象中文名，如 监测器）
 *   OperationDesc      -> description
 *   OperationAssociation -> association（菜单路径）
 *   OperationResults   -> status（'1'/'0' <-> SUCCESS/FAIL）
 *   Operator           -> operator
 *   LocalIP            -> localIp
 *   IPAddress          -> ipAddress
 *   CreatedDateTime    -> operationTime
 */
import { ofbiz } from './http';
import { adaptOperationAuditToLegacy } from './adapters';

/**
 * 查询操作审计列表
 *
 * 后端 data 为数组（total 在外层，http 基座不透出；表格为前端本地分页，
 * 用数组长度作为 total 即可）。
 *
 * @param {object} [params] 查询条件（新契约字段）
 * @param {string} [params.startTime] 开始时间 yyyy-MM-dd HH:mm:ss
 * @param {string} [params.endTime]   结束时间 yyyy-MM-dd HH:mm:ss
 * @param {string} [params.module]        操作对象（精确）
 * @param {string} [params.operationType] 操作类型（精确，小写 key）
 * @param {string} [params.status]        操作结果 SUCCESS/FAIL
 * @param {number} [params.page]          页码
 * @param {number} [params.pageSize]      每页条数
 * @returns {Promise<object>} { list: 已适配为旧契约的行, total }
 */
export function getOperationAuditList(params = {}) {
  return ofbiz.post('operationAudit/list', null, params).then(data => {
    const list = Array.isArray(data) ? data : ((data && data.list) || []);
    return { list: list.map(adaptOperationAuditToLegacy), total: list.length };
  });
}

/**
 * 记录操作审计日志
 *
 * @param {object} params 新契约字段（module/operationType/description/association/status 等）
 * @returns {Promise<object>} 创建后的审计记录（含 noteId）
 */
export function createOperationAuditLog(params = {}) {
  return ofbiz.post('operationAudit/create', params);
}

/**
 * 更新操作审计记录结果
 *
 * @param {object} params { noteId, status }
 * @returns {Promise<object>} 更新后的审计记录
 */
export function updateOperationAuditLog(params = {}) {
  return ofbiz.post('operationAudit/update', params);
}
